import { Component, Input, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, Validator } from '@angular/forms';
import { PGUtilities } from '../../utilities/pg-utilities';

@Component({
    selector: 'app-pg-email',
    templateUrl: './pg-email.component.html',
    styleUrls: ['./pg-email.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PgEmailComponent),
            multi: true
        }, {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => PgEmailComponent),
            multi: true,
        }],
    standalone: false
})
export class PgEmailComponent implements OnInit, ControlValueAccessor, Validator {
    @Input() fieldId:string;
    @Input() ariaInvalid:boolean;
    @Input() ariaDescribedBy:string;

    @Input() readonly: boolean;
    @Input() required: boolean;

    value:string

    constructor() { }

    ngOnInit(): void {
    }

    onValueChange() {
        if(this._onTouched) this._onTouched();
        if(this._onChange) {
            if(this.value == null || !PGUtilities.emailRegExp.test(this.value)) {
                this._onChange(null);
            }
            else {
                this._onChange(this.value);
            }
        }
    }

    _onChange;

    registerOnChange(fn: any) {
        this._onChange = fn;
    }

    _onTouched;

    registerOnTouched(fn: any) {
        this._onTouched = fn;
    }

    // INTERFACCIA ControlValueAccessor

    writeValue(obj: any) {
        this.value = obj;
    }

    // INTERFACCIA Validator

    validate() {
        if(this.value == null || this.value == '') {
            if(this.required) {
                return {
                    required: {
                        valid: false
                    }
                } 
            }
        }
        else {
            if(!PGUtilities.emailRegExp.test(this.value)) {
                return {
                    format: {
                        valid: false
                    }
                } 
            }
        }
    };
}
  